<script>
import Layout from '@layouts/main'
import appConfig from '@src/app.config'
import api from '@/odooapi'
import rpc from '@/odoorpc'
import or from 'vuelidate/lib/validators/or'

/**
 * Dashboard-1 Component
 */
export default {
  page: {
    title: '销售订单',
    meta: [{
      name: 'description',
      content: appConfig.description
    }],
  },
  components: {
    Layout,
  },

  data() {
    return {
      // 查询参数
      queryParams: {
        roleName: undefined,
        roleKey: undefined,
        status: undefined
      },
      // 显示搜索条件
      showSearch: true,

      maxHeight: '328px',
      // 日期范围
      dateRange: [],
      // 数据列表
      salesList: [],
      //
      allDate: [],

      paginationData: {   // 分页信息
        // 总数据条数
        total:0,
        // 当前页
        currentPage:1,
        // 每页展示几条数据
        page_Size:10,
      },

      infoPageData:{
        total:0,
        currentPage:1,
        page_Size:10,
      },
      orderId:'',

      // 查询参数
      // queryParams: {
      //   pageNum: 0,
      //   pageSize: 10,
      // },
      // domain: [],
      // fields: ['partner_id', 'order_id', 'client_order_ref', 'order_type', 'product_cat',
      //   'product_tmpl_id', 'production_qty'
      // ],
      // order: 'id DESC',
      state: '',
      options: [{
        value: '选项1',
        label: '新建'
      }, {
        value: '选项2',
        label: '报价'
      }, {
        value: '选项3',
        label: '评审'
      }, {
        value: '选项4',
        label: '确认'
      }, {
        value: '选项5',
        label: '执行'
      }],
      value: '',
      dialogVisible:false,
      // 物料核料明细
      tableDataDetails:[]

    }
  },
  created() {
    // this.getList()
    this.getData()
  },
  methods: {
    // 查询核料明细
    info(order_id){
      this.orderId = order_id
      this.dialogVisible = true

      rpc.web.dataset.call_kw({
        model:'sale.order.productions',
        method:'search_sale_order_productions_info',
        args:[],
        kwargs:{
          "order_id":order_id,
          "currentPage":this.infoPageData.currentPage,
          "pageSize":this.infoPageData.page_Size,
        }
      })
      .then(res=>{
        this.tableDataDetails = res.data
        this.infoPageData.total = res.total
      })

    },
    // 物料核料明细分页
    infoPageSize(page_size){
      this.infoPageData.page_Size = page_size
      this.info(this.orderId)

    },
    infoPageChange(pageNum){
      this.infoPageData.currentPage=pageNum
      this.info(this.orderId)
    },
    // 关闭对话框
    infoClose(){
      this.dialogVisible = false
      this.infoPageData.currentPage = 1
    },

    /** 搜索按钮操作 */
    handleQuery() {
      if(!this.queryParams.roleName || !this.queryParams.roleKey){
        this.paginationData.currentPage = 1
        
      }
      this.getData()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParams.roleName = ""
      this.queryParams.roleKey = ""
      this.paginationData.currentPage = 1
      this.getData()
    },
    // 分页
    handlePageSize(page_size){
      this.paginationData.page_Size=page_size
      // 这里写获取的的方法
      this.getData()

    },
    handlePageChange(pageNum){
      this.paginationData.currentPage=pageNum
      // 这里写获取的的方法
      this.getData()
    },
    getData(){
      rpc.web.dataset.call_kw({
        model: 'sale.order.productions',
        method: 'search_sale_order_productions',
        args: [],
        kwargs: {
          "currentPage":this.paginationData.currentPage,
          "pageSize":this.paginationData.page_Size,
          "client_order_ref":this.queryParams.roleName,
          "product_tmpl_name":this.queryParams.roleKey
        }
      })
      .then(res=>{
        this.salesList = res.data
        this.paginationData.total = res.total
        
      })
      .catch(err=>{

      })
    },

    // handleSizeChange(val) {
    //   this.paginationData.pageSize = val
    //   this.getList()
    // },
    // handleCurrentChange(val) {
    //   this.paginationData.pageIndex = val
    //   this.getList()
    // },

    // getList() {
    //   this.queryParams.pageNum = 0;
    //   // const Model = api.env.model('sale.order.productions')
    //   rpc.web.dataset.call_kw({
    //     model: 'sale.order.productions',
    //     method: 'search_sale_order_productions',
    //     args: [],
    //     kwargs: {}
    //   }).then(res => {
    //     this.allData = res
    //     this.salesList = this.allData.slice((this.paginationData.pageIndex - 1) * this.paginationData.pageSize, this.paginationData.pageIndex * this.paginationData.pageSize)
    //     this.paginationData.total = this.allData.length
    //     this.tableData.forEach((el, i) => {
    //       el.$index = (this.paginationData.pageIndex - 1) * this.paginationData.pageSize + 1 + i;
    //     });
    //   })
    // },
  }
}
</script>

<template>
  <Layout>
    <div class="row page-title align-items-center">
      <div class="col-sm-4 col-xl-6">
        <h4 class="mb-1 mt-0">订单中心</h4>
      </div>
      <!--      <div class="col-sm-4 col-xl-6 text-sm-right">-->
      <!--        <div class="btn-group ml-2 d-none d-sm-inline-block">-->
      <!--          <button type="button" class="btn btn-soft-primary btn-sm">-->
      <!--            <i class="uil uil-edit mr-1"></i>创建-->
      <!--          </button>-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
    <div class="row">
      <div class="col">
        <div class="card">
          <div class="card-body p-0">
            <el-form :model="queryParams" ref="queryForm" v-show="showSearch" :inline="true" class="p-3">
              <el-form-item label="客户订单编号" prop="roleName">
                <el-input v-model="queryParams.roleName" placeholder="请输入订单编号" clearable size="small"
                          style="width: 240px" @keyup.enter.native="handleQuery"/>
              </el-form-item>
              <el-form-item label="规格型号" prop="roleKey">
                <el-input v-model="queryParams.roleKey" placeholder="请输入规格型号" clearable size="small"
                          style="width: 240px" @keyup.enter.native="handleQuery"/>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索
                </el-button>
                <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
              </el-form-item>
            </el-form>
            <div style="margin-top: -0.6rem;">
              <el-table :data="salesList" style="width: 100%" class="p-3">
                <el-table-column type="selection" width="55" align="center"/>
                <!-- <el-table-column prop="partner_name" label="客户"/> -->
                <el-table-column prop="order_name" label="订单编号"/>
                <el-table-column prop="client_order_ref" label="客户订单编号"/>
                <el-table-column prop="order_type" label="订单类型"/>
                <el-table-column prop="product_cat" label="订单名称"/>
                <el-table-column prop="product_tmpl_name" label="规格型号"/>
                <el-table-column prop="production_qty" label="订单数量"/>

                <el-table-column label="查看明细">
                  <template slot-scope="scope">
                    <el-button type="primary" size="mini" @click="info(scope.row.order_id)">核料详情</el-button>
                  </template>
                </el-table-column>

              </el-table>
            </div>

            <el-dialog
                  :visible.sync="dialogVisible"
                  :close-on-click-modal="false"
                  :close-on-press-escape="false"
                  :show-close="false"
                  title="物料核料明细"
                  width="80%"
              >
                <el-table
                    :data="tableDataDetails"
                    style="width: 100%">
                  <el-table-column
                      prop="bom_line_name"
                      label="物料名称">
                  </el-table-column>
                  <el-table-column
                      prop="bom_line_model"
                      label="物料类型">
                  </el-table-column>
                  <el-table-column
                      prop="bom_line_product_qty"
                      label="需求数量">
                  </el-table-column>
                  <el-table-column
                      prop="bom_line_incoming"
                      label="来料数量">
                  </el-table-column>
                </el-table>


                <span slot="footer" class="dialog-footer">
                  <el-button type="danger" @click="infoClose">关闭</el-button>
                </span>
                
                <el-pagination
                  background
                  style="margin-top: 20px; text-align: right;"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="infoPageData.total"
                  :current-page="infoPageData.currentPage"
                  :page-size="infoPageData.page_Size"
                  :page-sizes="[10, 30, 50]"
                  @size-change="infoPageSize"
                  @current-change="infoPageChange"
                >
                </el-pagination>

                
              </el-dialog>

            <!-- <el-pagination background style="margin-top: 20px; text-align: right;"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="paginationData.total"
                           @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="paginationData.pageIndex" :page-sizes="[10, 30, 50]"
                           :page-size="paginationData.pageSize"
            >
            </el-pagination> -->


            <el-pagination
                background
                style="margin-top: 20px; text-align: right;"
                layout="total, sizes, prev, pager, next, jumper"
                :total="paginationData.total"
                :current-page="paginationData.currentPage"
                :page-size="paginationData.page_Size"
                :page-sizes="[10, 30, 50]"
                @size-change="handlePageSize"
                @current-change="handlePageChange"
                >
            </el-pagination>
            
          </div>
        </div>
      </div>
    </div>

  </Layout>
</template>

<style>
.el-table th.el-table__cell {
  background-color: #f8f8f9;
}

.el-form-item {
  margin-bottom: -0.5rem;
}

.el-table th.el-table__cell.is-leaf,
.el-table td.el-table__cell {
  border-bottom: 1px solid #dfe6ec;
}

.el-table .el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
  margin-left: 5px;
}
</style>
